<template>

    <FloatingPanel title="Formulier" :width="400">

        <div class="canvas-blocks-sky-formAlfa-BlockPanel">

            <Tabs :tabs="[
                'Formulier',
                'Algemeen',
            ]">

                <div slot="Formulier">

                    <div class="m-5">

                        <div class="mb-1 text-gray-600">Welk formulier?</div>

                        <small class="block mb-3 text-gray-500 text-muted">Kies hier het formulier wat getoond dient
                            te gaan worden.</small>

                        <v-select
                            :options="forms"
                            label="name"
                            v-model="options.form_id"
                            :reduce="form => form.id">

                            <div slot="no-options">Geen opties</div>

                        </v-select>

                    </div>

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"/>

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import axios from "axios";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

    data() {
        return {
            forms: [],
        };
    },

    created() {
        this.loadForms();
    },

    methods: {

        async loadForms() {
            // Load artists.
            this.forms = (await axios.get(this.adminUrlPrefix + '/forms')).data;
        },

    },

}

</script>

<style lang="scss">

.canvas-blocks-sky-formAlfa-BlockPanel {

    .vs__dropdown-menu {
        position: static;
    }

}

</style>
